/* src/app/pages/ortho/doctores-public/doctores-public.component.scss */
.doctores-public-container {
  background: #aaaaaa;
  color: #000000;
  text-align: justify;
  padding: 100px 0 0 0;
  line-height: normal;
  font-size: 18px;
}
.img-derecha-doctores {
  position: absolute;
  bottom: 0;
}
/*# sourceMappingURL=doctores-public.component.css.map */
